export default "__VITE_PUBLIC_ASSET__de7ab25d__"